// src/components/search/NewsResultCard.tsx

import React from 'react';
import { Card, CardContent, Typography, Chip, Stack, Box } from '@mui/material';
import { Article } from '@mui/icons-material';
import { NewsArticle } from '@/types/news.types';
import { formatDate } from './utils/dateFormatters';

interface NewsResultCardProps {
  article: NewsArticle;
  onNavigate: (article: NewsArticle) => void;
}

export const NewsResultCard: React.FC<NewsResultCardProps> = ({ article, onNavigate }) => (
  <Card
    sx={{
      mb: 2,
      cursor: 'pointer',
      '&:hover': { boxShadow: 3 },
      transition: 'box-shadow 0.2s'
    }}
    onClick={() => onNavigate(article)}
  >
    <CardContent>
      <Stack direction="row" spacing={2} alignItems="flex-start">
        <Article sx={{ color: 'primary.main', mt: 0.5 }} />
        <Box flex={1}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
            {article.title}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {article.summary || article.content?.substring(0, 150) + '...'}
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            <Chip label={article.tag} size="small" color="primary" variant="outlined" />
            <Typography variant="caption" color="text.secondary">
              {formatDate(article.date)}
            </Typography>
          </Stack>
        </Box>
      </Stack>
    </CardContent>
  </Card>
);
